import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {Picker as $933e5a05c989c3a1$export$ba25329847403e11} from "../picker/Picker.mjs";
import {SlotProvider as $62024859ff9f1f8a$export$8107b24b91795686} from "../utils/Slots.mjs";
import "../tabs_vars.css";
import $hUymF$tabs_vars_cssmjs from "../tabs_vars_css.mjs";
import {Text as $f8cc90fea9436c19$export$5f1af8db9871e1d6} from "../text/Text.mjs";
import {unwrapDOMRef as $3c2c983d5210446c$export$c7e28c72a4823176, useDOMRef as $3c2c983d5210446c$export$c2c55ef9111cafd8} from "../utils/useDOMRef.mjs";
import {useProvider as $71dfb0e0358a12de$export$693cdb10cec23617, useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {useTab as $hUymF$useTab, useTabList as $hUymF$useTabList, useTabPanel as $hUymF$useTabPanel} from "react-aria/useTabList";
import {filterDOMProps as $hUymF$filterDOMProps} from "react-aria/filterDOMProps";
import {FocusRing as $hUymF$FocusRing} from "react-aria/FocusRing";
import {Item as $hUymF$Item} from "react-stately/Item";
import {ListCollection as $hUymF$ListCollection} from "react-stately/private/list/ListCollection";
import {mergeProps as $hUymF$mergeProps} from "react-aria/mergeProps";
import $hUymF$react, {useRef as $hUymF$useRef, useState as $hUymF$useState, useEffect as $hUymF$useEffect, useCallback as $hUymF$useCallback, useContext as $hUymF$useContext} from "react";
import {useTabListState as $hUymF$useTabListState} from "react-stately/useTabListState";
import {useCollection as $hUymF$useCollection} from "react-stately/private/collections/useCollection";
import {useHover as $hUymF$useHover} from "react-aria/useHover";
import {useId as $hUymF$useId} from "react-aria/useId";
import {useLayoutEffect as $hUymF$useLayoutEffect} from "react-aria/private/utils/useLayoutEffect";
import {useLocale as $hUymF$useLocale} from "react-aria/I18nProvider";
import {useResizeObserver as $hUymF$useResizeObserver} from "react-aria/private/utils/useResizeObserver";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 





















const $c2743f8acf871c83$var$TabContext = /*#__PURE__*/ (0, $hUymF$react).createContext(null);
const $c2743f8acf871c83$export$b2539bed5023c21c = /*#__PURE__*/ (0, $hUymF$react).forwardRef(function Tabs(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    let { orientation: orientation = 'horizontal', density: density = 'regular', children: children, ...otherProps } = props;
    let domRef = (0, $3c2c983d5210446c$export$c2c55ef9111cafd8)(ref);
    let tablistRef = (0, $hUymF$useRef)(null);
    let wrapperRef = (0, $hUymF$useRef)(null);
    let { direction: direction } = (0, $hUymF$useLocale)();
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(otherProps);
    let [collapsed, setCollapsed] = (0, $hUymF$useState)(false);
    let [selectedTab, setSelectedTab] = (0, $hUymF$useState)(null);
    const [tabListState, setTabListState] = (0, $hUymF$useState)(null);
    let [tabPositions, setTabPositions] = (0, $hUymF$useState)([]);
    let prevTabPositions = (0, $hUymF$useRef)(tabPositions);
    (0, $hUymF$useEffect)(()=>{
        if (tablistRef.current) {
            let selectedTab = tablistRef.current.querySelector(`[data-key="${CSS.escape(tabListState?.selectedKey?.toString() ?? '')}"]`);
            if (selectedTab != null) setSelectedTab(selectedTab);
        }
    // collapse is in the dep array so selectedTab can be updated for TabLine positioning
    }, [
        children,
        tabListState?.selectedKey,
        collapsed,
        tablistRef
    ]);
    let checkShouldCollapse = (0, $hUymF$useCallback)(()=>{
        if (wrapperRef.current && orientation !== 'vertical') {
            let tabsComponent = wrapperRef.current;
            let tabs = tablistRef.current?.querySelectorAll('[role="tab"]') ?? new NodeList();
            let tabDimensions = [
                ...tabs
            ].map((tab)=>tab.getBoundingClientRect());
            let end = direction === 'rtl' ? 'left' : 'right';
            let farEdgeTabList = tabsComponent.getBoundingClientRect()[end];
            let farEdgeLastTab = tabDimensions[tabDimensions.length - 1][end];
            let shouldCollapse = direction === 'rtl' ? farEdgeLastTab < farEdgeTabList : farEdgeTabList < farEdgeLastTab;
            setCollapsed(shouldCollapse);
            if (tabDimensions.length !== prevTabPositions.current.length || tabDimensions.some((box, index)=>box?.left !== prevTabPositions.current[index]?.left || box?.right !== prevTabPositions.current[index]?.right)) {
                setTabPositions(tabDimensions);
                prevTabPositions.current = tabDimensions;
            }
        }
    }, [
        tablistRef,
        wrapperRef,
        direction,
        orientation,
        setCollapsed,
        prevTabPositions,
        setTabPositions
    ]);
    (0, $hUymF$useLayoutEffect)(()=>{
        checkShouldCollapse();
    }, [
        children,
        checkShouldCollapse
    ]);
    (0, $hUymF$useResizeObserver)({
        ref: wrapperRef,
        onResize: checkShouldCollapse
    });
    let tabPanelProps = {
        'aria-labelledby': undefined
    };
    // When the tabs are collapsed, the tabPanel should be labelled by the Picker button element.
    let collapsibleTabListId = (0, $hUymF$useId)();
    if (collapsed && orientation !== 'vertical') tabPanelProps['aria-labelledby'] = collapsibleTabListId;
    return /*#__PURE__*/ (0, $hUymF$react).createElement($c2743f8acf871c83$var$TabContext.Provider, {
        value: {
            tabProps: {
                ...props,
                orientation: orientation,
                density: density
            },
            tabState: {
                tabListState: tabListState,
                setTabListState: setTabListState,
                selectedTab: selectedTab,
                collapsed: collapsed
            },
            refs: {
                tablistRef: tablistRef,
                wrapperRef: wrapperRef
            },
            tabPanelProps: tabPanelProps,
            tabLineState: tabPositions
        }
    }, /*#__PURE__*/ (0, $hUymF$react).createElement("div", {
        ...(0, $hUymF$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'spectrum-TabsPanel', `spectrum-TabsPanel--${orientation}`, styleProps.className)
    }, props.children));
});
// @private
function $c2743f8acf871c83$var$Tab(props) {
    let { item: item, state: state } = props;
    let { key: key, rendered: rendered } = item;
    let ref = (0, $hUymF$useRef)(undefined);
    let { tabProps: tabProps, isSelected: isSelected, isDisabled: isDisabled } = (0, $hUymF$useTab)({
        key: key
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $hUymF$useHover)({
        ...props
    });
    let ElementType = item.props.href ? 'a' : 'div';
    return /*#__PURE__*/ (0, $hUymF$react).createElement((0, $hUymF$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $hUymF$react).createElement(ElementType, {
        ...(0, $hUymF$mergeProps)(tabProps, hoverProps),
        ref: ref,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'spectrum-Tabs-item', {
            'is-selected': isSelected,
            'is-disabled': isDisabled,
            'is-hovered': isHovered
        })
    }, /*#__PURE__*/ (0, $hUymF$react).createElement((0, $62024859ff9f1f8a$export$8107b24b91795686), {
        slots: {
            icon: {
                size: 'S',
                UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'spectrum-Icon')
            },
            text: {
                UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'spectrum-Tabs-itemLabel')
            }
        }
    }, typeof rendered === 'string' ? /*#__PURE__*/ (0, $hUymF$react).createElement((0, $f8cc90fea9436c19$export$5f1af8db9871e1d6), null, rendered) : rendered)));
}
// @private
function $c2743f8acf871c83$var$TabLine(props) {
    let { orientation: orientation, selectedTab: // Is either the tab node (non-collapsed) or the picker node (collapsed)
    selectedTab, selectedKey: // selectedKey is provided so that the TabLine styles are updated when the TabPicker's width updates from a selection change
    selectedKey } = props;
    let { direction: direction } = (0, $hUymF$useLocale)();
    let { scale: scale } = (0, $71dfb0e0358a12de$export$693cdb10cec23617)();
    let { tabLineState: tabLineState } = (0, $hUymF$useContext)($c2743f8acf871c83$var$TabContext);
    let [style, setStyle] = (0, $hUymF$useState)({
        width: undefined,
        height: undefined
    });
    let onResize = (0, $hUymF$useCallback)(()=>{
        if (selectedTab) {
            let styleObj = {
                transform: undefined,
                width: undefined,
                height: undefined
            };
            // In RTL, calculate the transform from the right edge of the tablist so that resizing the window doesn't break the Tabline position due to offsetLeft changes
            let offset = direction === 'rtl' ? -1 * (selectedTab.offsetParent?.offsetWidth - selectedTab.offsetWidth - selectedTab.offsetLeft) : selectedTab.offsetLeft;
            styleObj.transform = orientation === 'vertical' ? `translateY(${selectedTab.offsetTop}px)` : `translateX(${offset}px)`;
            if (orientation === 'horizontal') styleObj.width = `${selectedTab.offsetWidth}px`;
            else styleObj.height = `${selectedTab.offsetHeight}px`;
            setStyle(styleObj);
        }
    }, [
        direction,
        setStyle,
        selectedTab,
        orientation
    ]);
    (0, $hUymF$useLayoutEffect)(()=>{
        onResize();
    }, [
        onResize,
        scale,
        selectedKey,
        tabLineState
    ]);
    return /*#__PURE__*/ (0, $hUymF$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'spectrum-Tabs-selectionIndicator'),
        role: "presentation",
        style: style
    });
}
function $c2743f8acf871c83$export$e51a686c67fdaa2d(props) {
    const tabContext = (0, $hUymF$useContext)($c2743f8acf871c83$var$TabContext);
    const { refs: refs, tabState: tabState, tabProps: tabProps, tabPanelProps: tabPanelProps } = tabContext;
    const { isQuiet: isQuiet, density: density, isEmphasized: isEmphasized, orientation: orientation } = tabProps;
    const { selectedTab: selectedTab, collapsed: collapsed, setTabListState: setTabListState } = tabState;
    const { tablistRef: tablistRef, wrapperRef: wrapperRef } = refs;
    // Pass original Tab props but override children to create the collection.
    const state = (0, $hUymF$useTabListState)({
        ...tabProps,
        children: props.children
    });
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(props);
    const { tabListProps: tabListProps } = (0, $hUymF$useTabList)({
        ...tabProps,
        ...props
    }, state, tablistRef);
    (0, $hUymF$useEffect)(()=>{
        // Passing back to root as useTabPanel needs the TabListState
        setTabListState(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.disabledKeys,
        state.selectedItem,
        state.selectedKey,
        props.children
    ]);
    let collapseStyle = collapsed && orientation !== 'vertical' ? {
        maxWidth: 'calc(100% + 1px)',
        overflow: 'hidden',
        visibility: 'hidden',
        position: 'absolute'
    } : {
        maxWidth: 'calc(100% + 1px)'
    };
    let stylePropsFinal = orientation === 'vertical' ? styleProps : {
        style: collapseStyle
    };
    if (collapsed && orientation !== 'vertical') tabListProps['aria-hidden'] = true;
    let tabListclassName = (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'spectrum-TabsPanel-tabs');
    const tabContent = /*#__PURE__*/ (0, $hUymF$react).createElement("div", {
        ...stylePropsFinal,
        ...tabListProps,
        ref: tablistRef,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'spectrum-Tabs', `spectrum-Tabs--${orientation}`, tabListclassName, {
            'spectrum-Tabs--quiet': isQuiet,
            'spectrum-Tabs--emphasized': isEmphasized,
            ['spectrum-Tabs--compact']: density === 'compact'
        }, orientation === 'vertical' && styleProps.className)
    }, [
        ...state.collection
    ].map((item)=>/*#__PURE__*/ (0, $hUymF$react).createElement($c2743f8acf871c83$var$Tab, {
            key: item.key,
            item: item,
            state: state,
            orientation: orientation
        })), /*#__PURE__*/ (0, $hUymF$react).createElement($c2743f8acf871c83$var$TabLine, {
        orientation: orientation,
        selectedTab: selectedTab
    }));
    if (orientation === 'vertical') return tabContent;
    else return /*#__PURE__*/ (0, $hUymF$react).createElement("div", {
        ...styleProps,
        ref: wrapperRef,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'spectrum-TabsPanel-collapseWrapper', styleProps.className)
    }, /*#__PURE__*/ (0, $hUymF$react).createElement($c2743f8acf871c83$var$TabPicker, {
        ...props,
        ...tabProps,
        visible: collapsed,
        id: tabPanelProps['aria-labelledby'],
        state: state,
        className: tabListclassName
    }), tabContent);
}
function $c2743f8acf871c83$export$5dae8d435677f210(props) {
    const { tabState: tabState, tabProps: tabProps } = (0, $hUymF$useContext)($c2743f8acf871c83$var$TabContext);
    const { tabListState: tabListState } = tabState;
    const factory = (0, $hUymF$useCallback)((nodes)=>new (0, $hUymF$ListCollection)(nodes), []);
    const collection = (0, $hUymF$useCollection)({
        items: tabProps.items,
        ...props
    }, factory, {
        suppressTextValueWarning: true
    });
    const selectedItem = tabListState && tabListState.selectedKey != null ? collection.getItem(tabListState.selectedKey) : null;
    return /*#__PURE__*/ (0, $hUymF$react).createElement($c2743f8acf871c83$var$TabPanel, {
        ...props,
        key: tabListState?.selectedKey
    }, selectedItem && selectedItem.props.children);
}
// @private
function $c2743f8acf871c83$var$TabPanel(props) {
    const { tabState: tabState, tabPanelProps: ctxTabPanelProps } = (0, $hUymF$useContext)($c2743f8acf871c83$var$TabContext);
    const { tabListState: tabListState } = tabState;
    let ref = (0, $hUymF$useRef)(null);
    const { tabPanelProps: tabPanelProps } = (0, $hUymF$useTabPanel)(props, tabListState, ref);
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(props);
    if (ctxTabPanelProps['aria-labelledby']) tabPanelProps['aria-labelledby'] = ctxTabPanelProps['aria-labelledby'];
    return /*#__PURE__*/ (0, $hUymF$react).createElement((0, $hUymF$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $hUymF$react).createElement("div", {
        ...styleProps,
        ...tabPanelProps,
        ref: ref,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'spectrum-TabsPanel-tabpanel', styleProps.className)
    }, props.children));
}
function $c2743f8acf871c83$var$TabPicker(props) {
    let { isDisabled: isDisabled, isEmphasized: isEmphasized, isQuiet: isQuiet, state: state, 'aria-labelledby': ariaLabeledBy, 'aria-label': ariaLabel, density: density, className: className, id: id, visible: visible } = props;
    let ref = (0, $hUymF$useRef)(null);
    let [pickerNode, setPickerNode] = (0, $hUymF$useState)(null);
    (0, $hUymF$useEffect)(()=>{
        let node = (0, $3c2c983d5210446c$export$c7e28c72a4823176)(ref);
        setPickerNode(node.current);
    }, [
        ref
    ]);
    let items = [
        ...state.collection
    ];
    let pickerProps = {
        'aria-labelledby': ariaLabeledBy,
        'aria-label': ariaLabel
    };
    const style = visible ? {} : {
        visibility: 'hidden',
        position: 'absolute'
    };
    return /*#__PURE__*/ (0, $hUymF$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'spectrum-Tabs', 'spectrum-Tabs--horizontal', 'spectrum-Tabs--isCollapsed', {
            'spectrum-Tabs--quiet': isQuiet,
            ['spectrum-Tabs--compact']: density === 'compact',
            'spectrum-Tabs--emphasized': isEmphasized
        }, className),
        style: style,
        "aria-hidden": visible ? undefined : true
    }, /*#__PURE__*/ (0, $hUymF$react).createElement((0, $62024859ff9f1f8a$export$8107b24b91795686), {
        slots: {
            icon: {
                size: 'S',
                UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'spectrum-Icon')
            },
            button: {
                focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'focus-ring')
            }
        }
    }, /*#__PURE__*/ (0, $hUymF$react).createElement((0, $933e5a05c989c3a1$export$ba25329847403e11), {
        ...pickerProps,
        id: id,
        items: items,
        ref: ref,
        isQuiet: true,
        isDisabled: !visible || isDisabled,
        selectedKey: state.selectedKey,
        disabledKeys: state.disabledKeys,
        onSelectionChange: (key)=>{
            if (key != null) state.setSelectedKey(key);
        },
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hUymF$tabs_vars_cssmjs))), 'spectrum-Tabs-picker')
    }, (item)=>/*#__PURE__*/ (0, $hUymF$react).createElement((0, $hUymF$Item), item.props, item.rendered)), pickerNode && /*#__PURE__*/ (0, $hUymF$react).createElement($c2743f8acf871c83$var$TabLine, {
        orientation: "horizontal",
        selectedTab: pickerNode,
        selectedKey: state.selectedKey
    })));
}


export {$c2743f8acf871c83$export$b2539bed5023c21c as Tabs, $c2743f8acf871c83$export$e51a686c67fdaa2d as TabList, $c2743f8acf871c83$export$5dae8d435677f210 as TabPanels};
//# sourceMappingURL=Tabs.mjs.map
